import { color, fontFamily } from './variable-constants';

export const defaultThemeVariables = {
  '--primary-color': color.vmRed,
  '--secondary-color': color.plum,
  '--tertiary-color': color.purple,
  '--primary-shadow': color.shadowRed,
  '--secondary-shadow': color.shadowPlum,
  '--tertiary-shadow': color.shadowPurple,

  '--action-primary': color.vmRed,
  '--action-primary-shadow': color.shadowRed,
  '--action-secondary': color.plum,
  '--action-secondary-shadow': color.shadowPlum,
  '--action-tertiary': color.purple,
  '--action-tertiary-shadow': color.shadowPurple,

  '--product-card-border-gradient-color-a': color.vmRed,
  '--product-card-border-gradient-color-b': color.vmBlue,
  '--product-card-border-gradient-color-c': color.vmBlueLight,
  '--product-card-border-black-friday-color': color.grey80,

  '--color-form-error-border-color': color.shadowRed,
  '--color-form-error-color': color.shadowRed,

  '--color-message-background-color': color.vmBlue,
  '--color-message-border-color': color.vmBlue,

  '--action-button-border-radius': '6.25rem',

  '--text-h1-font-family': fontFamily.vMCircularWhisperPTT,
  '--text-h1-font-weight': 300,
  '--text-h1-font-size': '1.875rem',
  '--text-h1-line-height': 1.28,
  '--text-h1-letter-spacing': 'normal',
  '--text-h1-font-family-md': fontFamily.vMCircularWhisperPTT,
  '--text-h1-font-weight-md': 300,
  '--text-h1-font-size-md': '2.25rem',
  '--text-h1-line-height-md': 1.27,
  '--text-h1-letter-spacing-md': 'normal',

  '--text-h1-secondary-line-height': 1.28,

  '--text-h2-font-family': fontFamily.vMCircularWhisperPTT,
  '--text-h2-font-weight': 300,
  '--text-h2-font-size': '1.5rem',
  '--text-h2-line-height': 1.25,
  '--text-h2-letter-spacing': 'normal',
  '--text-h2-font-family-md': fontFamily.vMCircularWhisperPTT,
  '--text-h2-font-weight-md': 300,
  '--text-h2-font-size-md': '1.75rem',
  '--text-h2-line-height-md': 1.29,
  '--text-h2-letter-spacing-md': 'normal',

  '--text-h2-secondary-font-family': fontFamily.vMCircularWhisperPTT,
  '--text-h2-secondary-font-size': '1.5rem',
  '--text-h2-secondary-line-height': 1.25,

  '--text-h2-secondary-font-size-md': '1.75rem',

  '--text-h2-tertiary-font-family': fontFamily.vMCircularWhisperPTT,
  '--text-h2-tertiary-font-size': '1.5rem',
  '--text-h2-tertiary-font-size-md': '1.75rem',

  '--text-h2-quaternary-font-family': fontFamily.vMCircularChatPTT,

  '--text-h3-font-family': fontFamily.vMCircularChatPTT,
  '--text-h3-font-weight': 300,
  '--text-h3-font-size': '1.3125rem',
  '--text-h3-line-height': 1.29,
  '--text-h3-letter-spacing': 'normal',
  '--text-h3-font-family-md': fontFamily.vMCircularChatPTT,
  '--text-h3-font-weight-md': 300,
  '--text-h3-font-size-md': '1.5rem',
  '--text-h3-line-height-md': 1.25,
  '--text-h3-letter-spacing-md': 'normal',

  '--text-h3-secondary-font-family': fontFamily.vMCircularChatPTT,
  '--text-h3-secondary-font-size': '1.3125rem',
  '--text-h3-secondary-font-size-md': '1.5rem',

  '--text-h3-tertiary-font-family': fontFamily.vMCircularChatPTT,
  '--text-h3-tertiary-font-size': '1.125rem',

  '--text-h3-quaternary-font-size-md': '1.5rem',

  '--text-h4-font-family': fontFamily.vMCircularChatPTT,
  '--text-h4-font-weight': 300,
  '--text-h4-font-size': '1.125rem',
  '--text-h4-line-height': 1.28,
  '--text-h4-letter-spacing': 'normal',

  '--text-h4-secondary-font-family': fontFamily.vMCircularChatPTT,
  '--text-h4-secondary-font-size': '1.125rem',

  '--text-h4-tertiary-font-family': fontFamily.vMCircularChatPTT,
  '--text-h4-tertiary-font-size': '1.125rem',
  '--text-h4-quaternary-font-family': fontFamily.vMCircularChatPTT,
  '--text-h4-quinary-font-family': fontFamily.vMCircularChatPTT,

  '--text-h5-font-family': fontFamily.vMCircularChatPTT,
  '--text-h5-font-weight': 300,
  '--text-h5-font-size': '1rem',
  '--text-h5-line-height': 1.25,
  '--text-h5-letter-spacing': 'normal',

  '--text-h5-secondary-font-family': fontFamily.vMCircularChatPTT,

  '--text-h5-tertiary-font-family': fontFamily.vMCircularChatPTT,

  '--text-h5-quaternary-font-family': fontFamily.vMCircularChatPTT,

  '--body-margin': 0,
  '--body-padding': 0,
  '--body-height': '100%',
  '--body-font-family': fontFamily.vMCircularWhisperPTT,
  '--body-font-size': '1rem',
  '--body-font-weight': 300,
  '--body-line-height': 1.5,
  '--body-color': color.grey80,
  '--body-secondary-color': color.grey80,
  '--body-secondary-font-size': '1rem',
  '--body-tertiary-font-size': '1rem',
  '--body-tertiary-font-weight': 'bold',

  '--body-secondary-font-family': fontFamily.vMCircularChatPTT,
  '--body-tertiary-font-family': fontFamily.vMCircularWhisperPTT,
  '--body-quaternary-font-family': fontFamily.vMCircularWhisperPTT,
  '--body-quinary-font-family': fontFamily.vMCircularWhisperPTT,

  '--body-quaternary-font-size': '0.875rem',

  '--body-strong-font-family': fontFamily.vMCircularChatPTT,
  '--body-strong-font-weight': 'bold',
  '--body-strong-secondary-font-family': fontFamily.vMCircularChatPTT,

  '--paragraph-font-stretch': 'normal',
  '--paragraph-font-style': 'normal',
  '--paragraph-letter-spacing': 'normal',
  '--paragraph-margin': 0,

  '--paragraph-font-family': fontFamily.vMCircularWhisperPTT,

  '--list-position': 'relative',
  '--list-width': '100%',
  '--list-font-family': fontFamily.vMCircularWhisperPTT,
  '--list-font-size': '1rem',
  '--list-font-weight': 300,
  '--list-font-stretch': 'normal',
  '--list-font-style': 'normal',
  '--list-line-height': 1.5,
  '--list-letter-spacing': 'normal',
  '--list-color': color.grey80,
  '--list-padding': 0,
  '--list-style-position': 'inside',

  '--list-item-padding-left': '0.75rem',
  '--list-item-span-position': 'absolute',
  '--list-item-span-left': '2.5rem',
  '--list-secondary-font-family': fontFamily.vMCircularChatPTT,

  '--text-pop-font-family': fontFamily.vMCircularChatPTT,
  '--text-pop-font-size': '1.875rem',
  '--text-pop-line-height': 1.27,

  '--text-pop-secondary-font-size': '1.875rem',

  '--text-hero-title-font-family': fontFamily.vMCircularYellPTT,
  '--text-hero-title-font-size': '1.625rem',
  '--text-hero-title-line-height': 1.38,
  '--text-hero-title-font-size-md': '3.625rem',
  '--text-hero-title-line-height-md': 1.24,

  '--text-hero-line-height': 1.67,
  '--text-hero-font-size': '1.125rem',
  '--text-hero-line-height-md': 1.5,
  '--text-hero-font-size-md': '1.25rem',

  '--text-light-font-weight': 300,
  '--text-light-font-family': fontFamily.vMCircularWhisperPTT,

  '--text-light-secondary-font-family': fontFamily.vMCircularWhisperPTT,

  '--text-book-font-weight': 400,
  '--text-book-font-family': fontFamily.vMCircularChatPTT,
  '--text-book-secondary-font-weight': 500,
  '--text-book-secondary-font-family': fontFamily.vMCircularChatPTT,
  '--text-book-tertiary-font-family': fontFamily.vMCircularChatPTT,

  '--text-medium-font-weight': 600,
  '--text-medium-font-family': fontFamily.vMCircularNatterPTT,

  '--text-bold-font-weight': 700,
  '--text-bold-font-family': fontFamily.vMCircularShoutPTT,
  '--text-bold-secondary-font-family': fontFamily.vMCircularShoutPTT,

  '--text-bold-secondary-font-weight': 900,
  '--text-bold-tertiary-font-family': fontFamily.vMCircularShoutPTT,
  '--text-bold-quaternary-font-family': fontFamily.vMCircularShoutPTT,

  '--text-black-font-weight': 900,
  '--text-black-font-family': fontFamily.vMCircularYellPTT,

  '--text-link-font-weight': 'normal',
  '--text-link-font-family': fontFamily.vMCircularChatPTT,
  '--text-link-color': color.purple,
  '--text-link-hover-color': color.grey80,

  '--text-accordion-title-bar-font-family': fontFamily.vMCircularChatPTT,
  '--text-accordion-title-bar-font-size': '1rem',

  '--text-input-font-family': fontFamily.vMCircularChatPTT,
  '--text-input-secondary-font-family': fontFamily.vMCircularWhisperPTT,

  '--text-banner-font-family': fontFamily.vMCircularNatterPTT.replace("'Helvetica', ", ''),
  '--text-banner-title-font-family': fontFamily.vMCircularNatterPTT,

  '--text-h4-banner-title-font-family': fontFamily.vMCircularChatPTT,
  '--color-banner-background-color': color.white,
  '--color-banner-border-color': color.purple,
  '--color-banner-floating-background-color': color.purple,
  '--color-banner-floating-color': color.white,
  '--text-h4-banner-description-font-family': fontFamily.vMCircularChatPTT,
  '--text-h4-banner-description-font-size': '1.125rem',
  '--color-banner-description-font-color': color.plum,
  '--footer-background-color': color.plum,
  '--footer-link-color': color.white,
  '--color-calendar-border-color': color.purple,
  '--color-toggle-background-color': color.purple,
  '--color-toggle-border-color': color.purple,
  '--color-toggle-hover-background-color': color.shadowPurple,
  '--color-toggle-hover-border-color': color.shadowPurple,
  '--product-card-timer-color': color.shadowRed,
  '--product-card-flare-text-color': color.white,
};
